"use client";

import useStoreKeys from "@/hooks/useStoreKeys";
import { getConfig } from "@/lib/searchspring/searchspring.config";
import { Tracker as SearchSpringTracker } from "@searchspring/snap-tracker";
import dynamic from "next/dynamic";
import { FC, useEffect } from "react";

interface Props {
	uid: string;
	sku: string;
}

const ProductViewEvent: FC<Props> = ({ uid, sku }) => {
	if (typeof window === "undefined") {
		return;
	}

	const { store } = useStoreKeys();
	const config = getConfig(store);

	useEffect(() => {
		const tracker = new SearchSpringTracker(config.globals);

		const response = tracker.track.product.view({
			uid,
			sku,
		});
	}, []);

	return null;
};

export const DynamicProductViewEvent = dynamic(
	() => import("@/components/SearchSpring/Tracker"),
	{
		ssr: false,
	},
);

export default ProductViewEvent;
